import { cleanClass } from '@shared/utils/cleanClass.js';

const PageSections = ({ children, name = '' }) => {
  return <div className={cleanClass(`comp-page-sections ${name}`)}>{children}</div>;
};

export default PageSections;
